<template>
    <div class="tempContent">
        <!--查询筛选-->
        <div class="filterWrap">
            <div class="filterItem">
                <div class="filterTitle">
                    用户ID
                </div>

                <div class="filterElement">
                    <t-input
                        placeholder="请输入用户ID"
                        :maxlength="32"
                        clearable
                        :size="inputSize"
                        
                    />
                </div>
            </div>

            <div class="filterItem">
                <div class="filterTitle">
                    用户名
                </div>

                <div class="filterElement">
                    <t-input
                        placeholder="请输入用户名"
                        maxlength="32"
                        clearable
                    />
                </div>
            </div>

            <div class="filterItem">
                <div class="filterTitle">
                    用户手机
                </div>

                <div class="filterElement">
                    <t-input
                        placeholder="请输入手机号"
                        :maxlength="11"
                        clearable
                    />
                </div>
            </div>

            <div class="filterItem">
                <div class="filterTitle">
                    状态
                </div>

                <div class="filterElement">
                    <t-select
                        :options="statusType"
                        filterable
                        clearable
                        placeholder="请选择"
                    />
                </div>
            </div>

            <div class="filterItem">
                <div class="filterTitle">
                    注册时间
                </div>

                <div class="filterElementTime">
                    <t-date-range-picker
                        format="YYYY-MM-DD HH:mm"
                        :enableTimePicker="true"
                        :placeholder="['开始时间', '结束时间']"
                        allowInput
                        clearable
                    />
                </div>
            </div>

            <div class="filterButton">
                <t-button>
                    查询
                </t-button>

                <t-button variant="outline">
                    重置
                </t-button>

                <t-button variant="outline">
                    导出
                </t-button>
            </div>


            

        </div>

        <!--用户列表-->
        <t-table
            :data="userData" 
            :columns="columns"
            tableLayout="fixed"
            :show-header="true"
            cell-empty-content="--"
            row-key="index"
            :pagination="pagination"
            resizable
            lazy-load
            size="large"
            @row-click="handleRowClick"
            bordered
            hover
        >
            <template #action="{ row }">
                <div class="tableActionButton">
                    <t-link
                        class="detail-action"
                        theme="primary"
                        hover="color"
                        @click="detailClick(row)"
                    >
                        查看
                    </t-link>

                    <t-link
                        class="status-action"
                        theme='primary'
                        hover="color"
                        @click="switchStatus(row)"
                    >
                        {{ row.status === '正常' ? '冻结' : '解除冻结' }}
                    </t-link>
                    
                </div>
            </template>
        </t-table>
    </div>
</template>

<script setup lang="jsx">
    import { ref, onMounted, reactive } from 'vue';
    import { useRouter } from 'vue-router';
    import { MessagePlugin, DialogPlugin } from 'tdesign-vue-next';
    import { formatTime } from '../../utils/datetime';
    import userAPI from '../../api/user-api'; 

    const router = useRouter(); 

    // 数据初始化
    const userData = ref([]);
    const loading = ref(false);
    

    /**
     * 表格列定义
     */
    const columns=ref([
        { colKey: 'userId', title: '用户ID', width: '160' },
        { colKey: 'userName', title: '用户名' },
        { colKey: 'phone', title: '手机号'},
        { colKey: 'registerTime', title: '注册时间' },
        { colKey: 'openId', title: 'openID'},
        { colKey: 'status', title: '状态'},
        { colKey: 'action', title: '操作', width: '200',},
    ]);

    /**
     * 分页数据
     */
    const pagination = reactive({
        total: 0,
        pageSize: 10,
        current: 1,
    });

    /**
     * 获取用户列表
     */
    const getUserList = async () => {
        loading.value = true;
        try {
            const result = await userAPI.getUserList(pagination.current, pagination.pageSize);
            
            //console.log('API返回结果:', result);

            if (result.success) {
                userData.value = result.data.user_data.map(user => ({
                    userId: user.user_id,  
                    userName: user.username,  
                    phone: user.phone,
                    registerTime: user.register_time ? formatTime(user.register_time) : '',
                    openId: user.openid, 
                    status: user.status === 1 ? '正常' : '已冻结'
                }));

                pagination.total = result.data.total;
                pagination.current = result.data.current_page;

            } else {
                MessagePlugin.error('获取用户列表失败：' + result.message);
            }
        } catch (error) {
            console.error('获取用户列表时发生错误:', error);
            MessagePlugin.error('获取用户列表时发生错误');
        } finally {
            loading.value = false;
        }
    };

    onMounted(() => {
        getUserList();
    });

    /**
     * 查看详情跳转
     */
    const detailClick = (row) => {
        router.push(`/user/user-detail/${row.userId}`);
    };

    /**
     * 修改状态
     */
    const switchStatus = (row) => {
        const newStatus = row.status === '正常' ? 0 : 1;
        const actionText = newStatus === 1 ? '解除冻结' : '冻结';

        const dialog = DialogPlugin.confirm({
            header: '提示',
            body: `确定${actionText}用户 "${row.userName}" 吗？`,
            confirmBtn: '确定',
            cancelBtn: '取消',
            onConfirm: async () => {
                try {
                    const result = await userAPI.updateUserStatus(row.userId, newStatus);
                    if (result.success) {
                        // 更新本地数据
                        row.status = newStatus === 1 ? '正常' : '已冻结';

                        // 注销弹窗
                        dialog.destroy();
                        MessagePlugin.success(`用户已${actionText}`);

                        // 重新加载用户列表以确保数据同步
                        await getUserList();
                    } else {
                        MessagePlugin.error('状态更新失败：' + result.message);
                    }
                } catch (error) {
                    console.error('更新用户状态时发生错误:', error);
                    MessagePlugin.error(`${actionText}失败，请重试`);
                }
            },
            onClose: () => {
                dialog.destroy();
            },
        });
    };

</script>

<style scoped>
    @import "./user-admin.css";
    @import "../../components/style/style-content.css";
    @import "../../components/style/style-table.css";
    @import "../../components/style/style-filter.css";
</style>
